import { Socket } from "./socket";
import { GetSocketOptions } from "./types";

const getChannelKey = (channel: string, options?: GetSocketOptions) => {
	return `${channel}#${options?.admin?.id}#${options?.profile?.bl_profile}#${options?.chat}#${options?.transcripts}`;
};

export class SocketManager {
	private sockets: Map<string, Socket> = new Map();

	public connectChannel = (channel: string, options?: GetSocketOptions): Socket | undefined => {
		const name = getChannelKey(channel, options);
		if (name.startsWith('#undefined')) {
			console.warn('Skipping ws channel', name, 'because it includes "undefined"');
			return;
		}

		if (!this.sockets.has(name)) {
			this.sockets.set(name, new Socket(channel, options));
		}

		const socket = this.sockets.get(name) as Socket;

		if (socket.gettingConnection) {
			return socket;
		} else if (socket.disconnected) {
			socket.reconnect(options);
		}

		return socket;
	};

	public getChannel = (channel: string, options?: GetSocketOptions) => {
		const name = getChannelKey(channel, options);
		return this.sockets.get(name);
	};

	public removeChannel = (channel: string, options?: GetSocketOptions) => {
		const name = getChannelKey(channel, options);
		this.sockets.get(name)?.disconnect();
	};

	public end = () => {
		for (const [key, socket] of this.sockets.entries()) {
			if (!socket.disconnected) {
				socket.disconnect();
				socket.end();
				this.sockets.delete(key);
			}
		}
	};
}